import { alertMessagesArgsConfig } from '../../utils/event_constants';

export const miscActions = [
  {
    name: 'runJavaScriptCode',
    category: 'runJavaScriptCode',
    label: 'Run JavaScript Code',
    args: [
      {
        name: 'runJavaScript',
        label: 'Run JavaScript',
        type: 'editor',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
